var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
        'pl-2': _vm.items.length >= 10 && _vm.items.length < 100,
        'pl-4': _vm.items.length < 10,
    }},[_vm._v("\n    "+_vm._s(_vm.items.length)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }